import { RewardFareClass } from 'constants/flight'

interface Params {
  isCharterBundleOffer: boolean
  selectedFareClass?: string
  filterFareClass?: string
  completeness?: 'complete' | 'outboundOnly' | 'inboundOnly'
  oneWayBundle?: boolean
}

export function shouldShowOneWayFlightSale({
  isCharterBundleOffer,
  selectedFareClass,
  filterFareClass,
  completeness,
  oneWayBundle,
}: Params): boolean {
  const isOneWayBundle = completeness ? completeness !== 'complete' : oneWayBundle
  return isCharterBundleOffer && !!isOneWayBundle &&
    (selectedFareClass ?? filterFareClass) === RewardFareClass.ECONOMY_REWARDS
}
